<template>
  <div class="d-flex justify-content-center align-items-center" style="height: 100vh; background-color: #f8f8f8;">
    <b-card class="text-center shadow-sm" style="width: 400px; padding: 2rem;">

      <div v-if="status === 'success'">
        <b-spinner variant="success" class="mb-2" style="width: 3rem; height: 3rem;" />
        <h4 class="text-success mt-1">{{ $t('Authentication Completed') }}</h4>
        <p class="text-muted mb-50">{{ $t('Integration linked successfully') }}</p>
        <p v-if="vendorLabel" class="font-weight-bold mb-50">{{ vendorLabel }}</p>
        <p class="text-muted small">{{ $t('This window will close automatically') }}</p>
      </div>

      <div v-else-if="status === 'error'">
        <feather-icon icon="XCircleIcon" size="48" class="text-danger mb-2" />
        <h4 class="text-danger mt-1">{{ $t('Authentication Failed') }}</h4>
        <p class="text-muted">{{ errorMessage }}</p>
        <p class="text-muted small">{{ $t('You can close this window and try again') }}</p>
      </div>

      <div v-else>
        <b-spinner variant="primary" class="mb-2" />
        <h4 class="mt-1">{{ $t('Processing') }}</h4>
      </div>

    </b-card>
  </div>
</template>

<script>
import { BCard, BSpinner } from 'bootstrap-vue'
import { ref, onMounted } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { getInboundVendorLabel } from '@/views/main/inbound-integrations/inboundVendors'

export default {
  name: 'OAuthCallback',
  components: {
    BCard,
    BSpinner
  },
  setup() {
    const status = ref('loading')
    const errorMessage = ref('')
    const vendorLabel = ref('')

    onMounted(() => {
      const urlParams = new URLSearchParams(window.location.search)
      status.value = urlParams.get('status') || 'loading'
      vendorLabel.value = getInboundVendorLabel(urlParams.get('vendor'))

      if (status.value === 'error') {
        errorMessage.value = urlParams.get('message') || i18n.t('An unknown error occurred')
      }

      if (window.opener) {
        window.opener.postMessage({
          type: 'oauth_callback_result',
          status: status.value,
          message: errorMessage.value,
          vendor: urlParams.get('vendor'),
        }, '*')

        if (status.value === 'success') {
          setTimeout(() => {
            window.close()
          }, 2000)
        }
      }
    })

    return {
      status,
      errorMessage,
      vendorLabel,
    }
  }
}
</script>
